// imports
import Link from 'next/link';

// lib files
import { VideoClass } from '@/lib/types/api/video';

// components
import ITSImage from '@/components/ITSImage/ITSImage';
import UserProgressBar from '@/components/UserProgressBar/UserProgressBar';
import PassportHoverOverlay from '@/components/VideoMezzanineLink/PassportHoverOverlay';
import Badge from '@/components/Badge/Badge';

// svgs
import CompassRoseCorner from '@/public/svg/compass-rose-corner.svg';

// styles
import styles from './VideoMezzanineLink.module.scss';

type VideoMezzanineLinkProps = {
  video: VideoClass;
  nowPlaying?: boolean;
  sizes?: string;
  // these props are really here for storybook development
  depIsNew?: boolean;
  depPercentageWatched?: number;
}

const VideoMezzanineLink = (props: VideoMezzanineLinkProps) => {
  const {
    video,
    nowPlaying = false,
    sizes,
    depIsNew = false,
    depPercentageWatched = 0,
  } = props;

  const imgSrc = video.images?.['asset-mezzanine-16x9'] || video.image;
  const isPassport = video.flags.is_mvod;
  const isVideoNewBool = depIsNew || !nowPlaying && video.flags.is_new;

  let VideoMezzanineLinkImageLinkClassNames = styles.video_mezzanine_link;

  if (nowPlaying) {
    VideoMezzanineLinkImageLinkClassNames += ` ${styles.video_mezzanine_link_now_playing}`;
  }

  // Use sizes if passed, if not, default to video row sizes
  const videoMezzanineSizes = sizes ? sizes : `
    (min-width: 1700px) 316px,
    (min-width: 1440px) calc((100vw - 208px)/5),
    (min-width: 768px) calc((100vw - 96px)/4),
    calc(50vw - 40px),
  `

  return (
    <div className={styles.video_mezzanine_link_wrapper}>
      <Link href={`/video/${video.slug}/`} className={VideoMezzanineLinkImageLinkClassNames}>
        {/* @TODO make image fallback for video */}
        {imgSrc && (
          <ITSImage
            src={imgSrc}
            alt={video.title}
            width={316}
            height={177}
            srcSetSizes={[[140, 79], [316, 177], [400, 225], [460, 259], [604, 340], [712, 400]]}
            sizes={videoMezzanineSizes}
            className={styles.video_mezzanine_link_image}
          />
        )}
      </Link>
      {isPassport && (
        <PassportHoverOverlay className={styles.passport_cta} />
      )}

      {isPassport && (
        <span className={styles.video_mezzanine_link_passport_badge}>
          <CompassRoseCorner />
        </span>
      )}

      {nowPlaying && (
        <Badge style={"coral"} className={styles.video_mezzanine_link_badge}>
          Now Playing
        </Badge>
      )}
      {isVideoNewBool && (
        <Badge style={"yellow"} className={styles.video_mezzanine_link_badge}>
          New
        </Badge>
      )}
      <UserProgressBar slug={video.slug} depPercentageWatched={depPercentageWatched} />
    </div>
  );
}

export default VideoMezzanineLink;
